import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { withTranslation } from 'react-i18next';
import {
  Button,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from '@cargomatic/ui';
import PhoneField from 'components/v2/forms/PhoneField';
import UserActionCreators from '../../../actions/UserActionCreators';

const getEmptyState = () => {
  return {
    vendor: {
      company_name: '',
      email: '',
      first_name: '',
      last_name: '',
      password: '',
      phone: '',
    },
  };
};

class RegisterVendor extends Component {
  constructor(props) {
    super(props);
    this.state = getEmptyState();
  }

  handlePhoneChange = (phone) => {
    this.setState((prevState) => {
      return {
        vendor: {
          ...prevState.vendor,
          phone,
        },
      };
    });
  };

  handleChange = (field) => (e) => {
    const {
      target: { value },
    } = e;
    this.setState((prevState) => {
      return {
        vendor: {
          ...prevState.vendor,
          [field]: value,
        },
      };
    });
  };

  handleRegister = (e) => {
    e.preventDefault();
    const { vendor } = this.state;
    UserActionCreators.addVendor({
      ...vendor,
    });
    this.setState(getEmptyState());
  };

  render() {
    const { vendor } = this.state;
    const { t } = this.props;
    const disabled =
      isEmpty(vendor.company_name) ||
      isEmpty(vendor.email) ||
      isEmpty(vendor.first_name) ||
      isEmpty(vendor.last_name) ||
      isEmpty(vendor.password) ||
      isEmpty(vendor.phone);

    return (
      <Card>
        <form onSubmit={this.handleRegister}>
          <CardHeader>
            <CardTitle>Add Vendor</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-4 gap-6 max-w-3xl">
              <div className="col-span-4 sm:col-span-2 space-y-2">
                <Label htmlFor="vendor-first-name">{t('FIRST_NAME')}</Label>
                <Input
                  id="vendor-first-name"
                  type="text"
                  placeholder="John"
                  onChange={this.handleChange('first_name')}
                  value={vendor.first_name}
                />
              </div>
              <div className="col-span-4 sm:col-span-2 space-y-2">
                <Label htmlFor="vendor-last-name">{t('LAST_NAME')}</Label>
                <Input
                  id="vendor-last-name"
                  type="text"
                  placeholder="Smith"
                  onChange={this.handleChange('last_name')}
                  value={vendor.last_name}
                />
              </div>
              <div className="col-span-4 sm:col-span-2 space-y-2">
                <Label htmlFor="vendor-company-name">{t('COMPANY_NAME')}</Label>
                <Input
                  id="vendor-company-name"
                  type="text"
                  placeholder={t('COMPANY_NAME')}
                  onChange={this.handleChange('company_name')}
                  value={vendor.company_name}
                />
              </div>
              <div className="col-span-4 sm:col-span-2 space-y-2">
                <Label htmlFor="vendor-phone">{t('PHONE')}</Label>
                <PhoneField
                  id="vendor-phone"
                  onChange={this.handlePhoneChange}
                  value={vendor.phone}
                />
              </div>
              <div className="col-span-4 sm:col-span-2 space-y-2">
                <Label htmlFor="vendor-email">{t('EMAIL')}</Label>
                <Input
                  id="vendor-email"
                  type="email"
                  placeholder="example@cargomatic.com"
                  onChange={this.handleChange('email')}
                  value={vendor.email}
                />
              </div>
              <div className="col-span-4 sm:col-span-2 space-y-2">
                <Label htmlFor="vendor-password">{t('PASSWORD')}</Label>
                <Input
                  id="vendor-password"
                  type="password"
                  placeholder={t('PASSWORD')}
                  onChange={this.handleChange('password')}
                  value={vendor.password}
                />
              </div>
            </div>
          </CardContent>
          <CardFooter className="justify-end">
            <Button disabled={disabled} type="submit">
              Register Vendor
            </Button>
          </CardFooter>
        </form>
      </Card>
    );
  }
}

export default withTranslation()(RegisterVendor);
